import axios from 'axios';
import isEmpty from 'lodash/isEmpty';

export function get(endpoint, options = { token: '', traceId: '', headers: {} }) {
    const { token, headers, traceId } = options;

    return new Promise((resolve) => {
        const reqHeaders = {
            authorization: 'Bearer ' + token,
            'x-trace-id': traceId,
            ...headers,
        };
        if (isEmpty(traceId)) delete reqHeaders['x-trace-id'];
        if (isEmpty(token)) delete reqHeaders.authorization;

        axios.get(endpoint, { headers: reqHeaders })
            .then(resolve)
            .catch(resolve);
    });
}

export default get;
